import EventsList from './EventsList';

export default EventsList;



// WEBPACK FOOTER //
// ./src/components/EventsList/index.tsx